import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  Show,
  SimpleShowLayout,
  EditButton,
  ShowButton,
  DeleteButton,
  TopToolbar,
  ExportButton,
  CreateButton,
} from 'react-admin';

const UserListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const UserList = () => (
  <List actions={<UserListActions />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <EmailField source="email" />
      <TextField source="phone" />
      <TextField source="roles" />
      <DateField source="createdAt" />
      <ShowButton />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const UserCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="email" type="email" />
      <TextInput source="phone" />
      <ArrayInput source="roles">
        <SimpleFormIterator>
          <SelectInput
            choices={[
              { id: 'VEHICLE_OWNER', name: 'Vehicle Owner' },
              { id: 'WORKSHOP_OWNER', name: 'Workshop Owner' },
              { id: 'ADMIN', name: 'Admin' },
            ]}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
);

export const UserEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="email" type="email" />
      <TextInput source="phone" />
      <ArrayInput source="roles">
        <SimpleFormIterator>
          <SelectInput
            choices={[
              { id: 'VEHICLE_OWNER', name: 'Vehicle Owner' },
              { id: 'WORKSHOP_OWNER', name: 'Workshop Owner' },
              { id: 'ADMIN', name: 'Admin' },
            ]}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);

export const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <EmailField source="email" />
      <TextField source="phone" />
      <TextField source="roles" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
